<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.unidade_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Documentos Vinculados
              <i class="fa fa-doc"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t4' + rowData.unidade_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Contas Bancárias Vinculados
              <i class="fa fa-money"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.unidade_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes Jurídicos
              <i class="fa fa-building"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.unidade_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes De Endereço
              <i class="fa fa-building"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t5' + rowData.unidade_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t7' + rowData.unidade_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Serviços e Emissão
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t6' + rowData.unidade_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.integracao_log.length > 0"
          >
            <span class="nav-link-in">
              Erros
              <i class="fa fa-times"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.unidade_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Tipo</th>
                <th style="width: 10%">Número Fiscal</th>
                <th style="width: 10%">Série</th>
                <th style="width: 10%">Número Controle</th>
                <th style="width: 15%">Data Inicio</th>
                <th style="width: 15%">Data Fim</th>
                <th style="width: 10%">Status</th>
                <th style="width: 10%">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.unidade_documento"
                :key="item.unidoc_id"
              >
                <td>
                  {{ item.param_tipo_doc.descr }}
                </td>
                <td>
                  {{ item.num_fiscal }}
                </td>
                <td>
                  {{ item.serie }}
                </td>
                <td>
                  {{ item.num_controle }}
                </td>
                <td>
                  <span> {{ DateFormat(item.dt_inicio) }} </span>
                </td>
                <td>
                  {{ DateFormat(item.dt_fim) }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
                <td>
                  <a
                    v-if="item.status.valor == 2"
                    @click="onActivateDesactivate(1, item, true)"
                    v-b-tooltip
                    title="Ativar"
                    ><i class="fa fa-thumbs-o-up"></i
                  ></a>
                  <a
                    v-if="item.status.valor == 1"
                    @click="onActivateDesactivate(2, item, true)"
                    v-b-tooltip
                    title="Inativar"
                    ><i class="fa fa-thumbs-o-down"></i
                  ></a>
                  <a @click="onEditDoc(item)" v-b-tooltip title="Alterar"
                    ><i class="fa fa-edit"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t4' + rowData.unidade_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Descrição</th>
                <th style="width: 10%">Conta</th>
                <th style="width: 2%">Digito</th>
                <th style="width: 10%">Agencia</th>
                <th style="width: 2%">Digito</th>
                <th style="width: 10%">Banco</th>
                <th style="width: 5%">Principal</th>
                <th style="width: 5%">Status</th>
                <th style="width: 10%">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.unidade_conta"
                :key="item.unicon_id"
              >
                <td>
                  {{ item.descr }}
                </td>
                <td>
                  {{ item.conta }}
                </td>
                <td>
                  {{ item.conta_dig }}
                </td>
                <td>
                  {{ item.agencia }}
                </td>
                <td>
                  {{ item.agencia_dig }}
                </td>
                <td>
                  {{ item.param_banco.descr }}
                </td>
                <td>
                  {{ item.principal.descr }}
                </td>
                <td>
                  <span
                    class="label label-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="label label-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
                <td>
                  <a @click="onEditConta(item)" v-b-tooltip title="Alterar"
                    ><i class="fa fa-edit"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t2' + rowData.unidade_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">CNPJ</th>
                <th style="width: 20%">Nome Fantasia</th>
                <th style="width: 20%">Razão Social</th>
                <th style="width: 10%">Inscrição Estadual</th>
                <th style="width: 10%">Inscrição Municipal</th>
                <th style="width: 10%">Inscrição Suframa</th>
                <th style="width: 10%">CD Regime Tributário</th>
                <th style="width: 10%">Segmento Contábil</th>
                <th style="width: 10%">Transação ERP</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{
                    onFormataCnpj(
                      rowData.pessoa.pessoa_juridica.cnpj_base,
                      rowData.pessoa.pessoa_juridica.cnpj_filial,
                      rowData.pessoa.pessoa_juridica.cnpj_digito
                    )
                  }}
                </td>
                <td>
                  {{ rowData.pessoa.pessoa_juridica.nome_fantasia }}
                </td>
                <td>
                  {{ rowData.pessoa.pessoa_juridica.razao_social }}
                </td>
                <td>
                  {{ rowData.pessoa.pessoa_juridica.inscricao_estadual }}
                </td>
                <td>
                  {{ rowData.pessoa.pessoa_juridica.inscricao_municipal }}
                </td>
                <td>
                  {{ rowData.pessoa.pessoa_juridica.inscricao_suframa }}
                </td>
                <td>
                  {{ rowData.pessoa.pessoa_juridica.cd_regime_tributario }}
                </td>
                <td>
                  {{ rowData.segmento_contabil }}
                </td>
                <td>
                  {{ rowData.transacao_erp }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t3' + rowData.unidade_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">CEP</th>
                <th style="width: 20%">Endereço</th>
                <th style="width: 10%">Bairro</th>
                <th style="width: 10%">Número</th>
                <th style="width: 10%">Complemento</th>
                <th style="width: 20%">Município</th>
                <th style="width: 10%">Tipo</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.pessoa_endereco.cep }}
                </td>
                <td>
                  {{ rowData.pessoa_endereco.endereco }}
                </td>
                <td>
                  {{ rowData.pessoa_endereco.bairro }}
                </td>
                <td>
                  {{ rowData.pessoa_endereco.numero }}
                </td>
                <td>
                  {{ rowData.pessoa_endereco.complemento }}
                </td>
                <td>
                  {{ rowData.pessoa_endereco.municipio.nome }}
                </td>
                <td>
                  {{ rowData.pessoa_endereco.parend.descr }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t5' + rowData.unidade_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th>Tipo regra montagem</th>
                <th>Tipo montagem carga</th>
                <th>Exige CTE montagem carga</th>
                <th>Tipo rateio</th>
                <th>Tipo quebra unidade de carga receita</th>
                <th>Tipo quebra unidade de carga despesa</th>
                <th>Código gestão de pagamento</th>
                <th>Realiza Triagem</th>
                <th>Utiliza modulo de conferencia</th>
                <th>Importa notas por manifesto</th>
                <th>Aviso prévio</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.tp_regra_montagem.descr }}
                </td>
                <td>
                  {{ rowData.liv_tp_montagem_carga.descr }}
                </td>
                <td>
                  {{ rowData.liv_exige_cte_montagem_carga.descr }}
                </td>
                <td>
                  {{ rowData.liv_tipo_rateio.descr }}
                </td>
                <td>
                  {{ rowData.tp_quebra_uc_receita.descr }}
                </td>
                <td>
                  {{ rowData.tp_quebra_uc_despesa.descr }}
                </td>
                <td>
                  {{ rowData.cd_gestao_pagto }}
                </td>
                <td>
                  {{ rowData.triagem.descr }}
                </td>
                <td>
                  {{ rowData.utiliza_modulo_conferencia.descr }}
                </td>
                <td>
                  {{ rowData.integracao_notas_por_manifesto.descr }}
                </td>
                <td>
                  <span
                    class="badge"
                    :class="{
                      'badge-danger':rowData.aviso_vencimento.valor == 2,
                      'badge-success':rowData.aviso_vencimento.valor == 1,
                    }"
                    >{{ rowData.aviso_vencimento.valor == 1 ? `${rowData.dias_vencimento} dias` : "Inativo"}}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t7' + rowData.unidade_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 50%">Tipo de serviço</th>
                <th style="width: 50%">Step emissão CTE/Montagem de carga</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <template v-if="getTiposServico(rowData).length">
                    <span
                      v-for="(item, idx) in getTiposServico(rowData)"
                      :key="idx"
                      class="badge badge-secondary mr-1 mb-1"
                    >
                      {{ item }}
                    </span>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <template v-if="getStepEmissaoCte(rowData)">
                    <span class="badge badge-secondary">
                      {{ getStepEmissaoCte(rowData)}}
                    </span>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t6' + rowData.unidade_id + ''"
          v-if="rowData.integracao_log.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Entidade</th>
                <th data-toggle="true" style="width: 80%">Descrição</th>
                <th data-toggle="true" style="width: 10%">Data erro</th>
              </tr>
            </thead>
            <tbody
              v-for="item2 in rowData.integracao_log"
              :key="item2.intlog_id"
            >
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="item2.integracao != null" class="badge badge-primary">{{
                    item2.integracao.descr
                  }}</span>
                </td>
                <td>
                  {{ item2.descr }}
                </td>
                <td>
                  {{ formatDateHora(item2.dt_inc) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
      <VincularContaUnidadeForm ref="vincularcontaunidadeform" />
      <VincularDocumentoUnidadeForm ref="vinculardocumentounidadeform" />
    </div>
  </div>
</template>

  <script>
import VincularContaUnidadeForm from "./VincularContaUnidadeForm.vue";
import VincularDocumentoUnidadeForm from "./VincularDocumentoUnidadeForm.vue";
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    VincularContaUnidadeForm,
    VincularDocumentoUnidadeForm,
  },
  data() {
    return {
      helpForm: new Form({ recordCollection: [], status: "" }),
      cnpj_formatado: "",
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onEditDoc(data) {
      this.$refs.vinculardocumentounidadeform.onEdit(data);
    },
    onEditConta(data) {
      this.$refs.vincularcontaunidadeform.onEdit(data);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.unidoc_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.vinculardocumentounidadeform.onActivateDesactivate(
        this.helpForm
      );
    },
    formatDateHora (value, fmt = 'DD/MM/YYYY HH:mm:ss') {
      return (value == null)
        ? ''
        : moment(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
    },

    getTiposServico(rowData) {
      const raw = rowData.param_tipo_servicos;

      if (raw == null || raw === '' || raw === undefined) return [];

      const arr = Array.isArray(raw) ? raw : [raw];

      return arr.map((item) => {
        if (item && typeof item === 'object') return item.descr || item.label || '';

        return String(item);
      }).filter(Boolean);
    },

    getStepEmissaoCte(rowData) {
      const raw = rowData.step_emissao;

      if (raw == null || raw === '' || raw === undefined) return '';

      const arr = rowData.param_tipo_servicos;

      if (!arr) return typeof raw === 'object' ? (raw.descr || raw.label || '') : String(raw);

      const filtered = arr.find((item) => {
        if (!item || typeof item !== 'object') return false;

        return item.partpserv_id == raw;
      });

      return filtered ? (filtered.descr || filtered.label || '') : '';
    },
  },
};
</script>